import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import OnFleetSettingInfoItem from './OnFleetSettingInfoItem'
import {
  Paper,
  Button,
  ListItem,
  Grid,
  Typography,
  withStyles,
  Tooltip,
  ExpansionPanelDetails,
} from '@material-ui/core'
import { EditableSwitch } from '../common/EditableComponents'
import InfoIcon from '@material-ui/icons/Info'
import { updateCompany } from '../../actions/company'

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip)

const useStyles = (theme) => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
})

class OnFleetSettingInfo extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedPanel: 0,
      infoAutoSendOnfleet1:
        '• Auto Send to Onfleet | Onfleet Team must be set to determine which team is assigned automatically to each order.',
      infoAutoSendOnfleet2:
        '• For each specified region, employees must be set up in Onfleet (Global Settings > Integration Settings > Onfleet > Employees).',
      infoAutoSendOnfleet3:
        '• Employees set up with Onfleet must be assigned a terminal (Global Settings > Manage Employees) with a region associated inventory (Global Settings > Current Shop Settings > Inventory).',
      editMode: false,
      autoOnFleetIncomingOrders: false,
    }
  }

  selectPanel = (selectedPanel) => () => {
    this.setState({
      selectedPanel,
    })
  }

  onChange = (key, value) => (e) => {
    this.setState({ [key]: !value })
  }

  onUpdate = () => {
    const { company = {} } = this.props
    const { autoOnFleetIncomingOrders } = this.state
    company.autoOnFleetIncomingOrders = autoOnFleetIncomingOrders

    this.props.dispatch(updateCompany(company)).then((res) => {
      this.toggleEdit()
    })
  }

  toggleEdit = () => {
    this.setState({
      editMode: !this.state.editMode,
      autoOnFleetIncomingOrders:
        (this.props.company && this.props.company.autoOnFleetIncomingOrders) || false,
    })
  }

  getOnfleetSettingsByShop = (shop) => {
    const { shopFeaturesList = [] } = this.props
    let shopFeaturesResult = []
    shopFeaturesList.map((shopFeatures) => {
      if (shopFeatures.shopId === shop.id) {
        shopFeaturesResult = shopFeatures
      }
    })
    return shopFeaturesResult
  }

  render() {
    const { selectedPanel, autoOnFleetIncomingOrders = false, editMode = false } = this.state
    const {
      shopsList = {},
      company = {},
      companyFeatures = {},
      onfleetTwoWays = {},
      classes,
    } = this.props
    const { availableApps = [] } = companyFeatures
    const { values = [] } = shopsList
    const shops = values || []

    return (
      <div>
        {availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') >= 0 && (
          <Paper className={classes.paper}>
            <ExpansionPanelDetails className="margin-top-small">
              <div className="full-width">
                {!editMode ? (
                  <Button className="primary-button pull-right" onClick={this.toggleEdit}>
                    {' '}
                    Edit{' '}
                  </Button>
                ) : (
                  <div className="pull-right margin-bottom-small">
                    <Button className="primary-button margin" onClick={this.onUpdate}>
                      Save
                    </Button>
                    <Button className="danger-button margin" onClick={this.toggleEdit}>
                      Cancel
                    </Button>
                  </div>
                )}
                <Grid className="listing-spacing" container>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <ListItem>
                      <Grid container>
                        <Grid
                          className="labelField"
                          style={{ fontSize: 16 }}
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={6}
                        >
                          Auto Send to Onfleet | Incoming Orders
                        </Grid>
                        <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                          <EditableSwitch
                            valueToRender={
                              autoOnFleetIncomingOrders || company.autoOnFleetIncomingOrders
                                ? 'Enabled'
                                : 'Disabled'
                            }
                            checked={autoOnFleetIncomingOrders}
                            editMode={editMode}
                            onChange={this.onChange(
                              'autoOnFleetIncomingOrders',
                              autoOnFleetIncomingOrders,
                            )}
                          />
                        </Grid>
                        <Grid>
                          <HtmlTooltip
                            placement="top-start"
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  <b>{'When enabled'}</b>, the following settings are required:
                                  <br />
                                  {this.state.infoAutoSendOnfleet1} <br />
                                  {this.state.infoAutoSendOnfleet2} <br />
                                  {this.state.infoAutoSendOnfleet3}
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoIcon style={{ color: '#03a9f4' }} />
                          </HtmlTooltip>
                        </Grid>
                      </Grid>
                    </ListItem>
                  </Grid>
                </Grid>
              </div>
            </ExpansionPanelDetails>
          </Paper>
        )}
        {shops.map((shop, index) => {
          if (shop.appTarget && shop.appTarget === 'Retail') {
            return (
              <OnFleetSettingInfoItem
                shop={shop}
                shopFeatures={this.getOnfleetSettingsByShop(shop)}
                onfleetTwoWaysEnabled={onfleetTwoWays[shop.id] || false}
                index={index}
                selectedPanel={selectedPanel}
                selectPanel={this.selectPanel}
                autoOnFleetIncomingOrders={
                  availableApps.length > 0 &&
                  availableApps &&
                  availableApps.indexOf('Dispatch') >= 0 &&
                  company.autoOnFleetIncomingOrders
                }
              />
            )
          }
        }) || null}
      </div>
    )
  }
}

export default withStyles(useStyles)(connect(({ dispatch }) => ({ dispatch }))(OnFleetSettingInfo))



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetSettingInfo.js